import { render, staticRenderFns } from "./orders-view.vue?vue&type=template&id=2ae82fa5&scoped=true&lang=pug"
import script from "./orders-view.js?vue&type=script&lang=js&external"
export * from "./orders-view.js?vue&type=script&lang=js&external"
import style0 from "./orders-view.vue?vue&type=style&index=0&id=2ae82fa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae82fa5",
  null
  
)

export default component.exports